import React from 'react';
import '../App.css';
import Cards from '../components/cards/Cards';

export default function Products() {
  return (
    <>
      <Cards />
    </>
  );
}
